import { RootStateType } from '../store';

export const servicesSelector = (state: RootStateType) => {
  return state.servicesReducer.services;
};

export const totalCountSelector = (state: RootStateType) => {
  return state.servicesReducer.totalCount;
};

export const isServicesLoadingSelector = (state: RootStateType) => {
  return !!state.servicesReducer.isServicesLoading;
};
